// extracted by mini-css-extract-plugin
export default {"inner":"styles_inner__efeIk","closeBtn":"styles_closeBtn__ck+8+","container":"styles_container__6pYdl","icon":"styles_icon__rCjr-","footerModal":"styles_footerModal__BQoWS"};